import FetchData from '@shared/utils/fetchData/fetchData';

export const removeProductFromCart = async (id?: string[]) => {
  return await FetchData.delete<{ message: string }>('cart', {
    body: JSON.stringify({ id })
  });
};
